import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CommentSection from 'app/components/layouts/Comments/CommentSection';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import { withGlobalData } from 'app/utils/withGlobalData';
import Image from 'app/components/layouts/Image';
import Title from 'app/components/layouts/Title';
import categories from 'app/data/videos.json';
import { useTranslation } from 'next-i18next';
import { NextSeo } from 'next-seo';
import Link from 'next/link';

const index = () => {
  const { t } = useTranslation();

  return (
    <section className="box-card-area">
      <NextSeo
        title={t('navigations.video')}
        description={t('videos.video_description', { type: t('navigations.video') })}
      />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <Title title="navigations.video" />
            <div className="flex-wrap mt-4">
              {
                categories.map((category, index: number) => {
                  return (
                    <Link
                      key={index}
                      className="font-weight-bold text-size-md d-flex wrap-box-content p-3 mx-auto my-5"
                      style={{ width: 500 }}
                      href={category.path}
                    >
                      <Image
                        width={30}
                        height={30}
                        disableAuto
                        className="mr-3"
                        alt={category.name}
                        src={category.image}
                      />
                      <div className="d-inline route-name cursor-pointer">
                        {t(`navigations.${category.name}`)}
                      </div>
                    </Link>
                  )
                })
              }
            </div>
            <CommentSection roomId="videos" />
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common']),
    }
  }
})

export default index;
